import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import './Flipbook.css';

function Flipbook() {
    const location = useLocation();
    const navigate = useNavigate();
    const flipbookRef = useRef(null);

    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const handleGoBack = () => navigate(-1);

    // 🔹 Fetch API
    useEffect(() => {
        const fetchData = async () => {
            try {
                const urlcomponent = location.pathname.split('/');
                const urlParam = urlcomponent[urlcomponent.length - 2];

                const url = `${process.env.REACT_APP_BACKEND_HOST}/api/v1/emagzines/get/v2?url=${urlParam}`;

                const res = await fetch(url);
                const result = await res.json();

                console.log('API:', result);
                setData(result);
            } catch (err) {
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [location]);

    // 🔥 COMMON: destroy instance
    const destroyFlipbook = () => {
        const $ = window.jQuery;
        if ($ && $.fn.flipBook) {
            const instance =
                $('#df_magazine').data('dflip') ||
                $('#df_magazine').data('flipBook');

            if (instance) {
                instance.dispose();
            }
        }
    };

    // 🔥 PDF ONLY (your original working logic)
    const initPdfFlipbook = (pdfUrl) => {
        const $ = window.jQuery;
        if (!$ || !$.fn.flipBook) return;

        console.log('PDF MODE');

        destroyFlipbook();

        const options = {
            height: '100%',
            display: "double",
            singlePageMode: false,
            backgroundColor: '#1a1a2e',
            duration: 800,
            autoEnableOutline: false,
            autoEnableThumbnail: false,
            enableDownload: false,
            controlsPosition: 'bottom',
            paddingTop: 0,
            paddingBottom: 50,
            paddingLeft: 0,
            paddingRight: 0,
            forceFit: true,
            soundEnable: true
        };

        $('#df_magazine').flipBook(pdfUrl, options);
    };

    // 🔥 IMAGE ONLY (separate clean logic)
    const initImageFlipbook = (images) => {
        const $ = window.jQuery;
        if (!$ || !$.fn.flipBook) return;

        console.log('IMAGE MODE');

        destroyFlipbook();

        const options = {
            height: '100%',
            display: "double",
            singlePageMode: false,
            backgroundColor: '#1a1a2e',
            duration: 800,
            autoEnableOutline: false,
            autoEnableThumbnail: false,
            enableDownload: false,
            controlsPosition: 'bottom',
            paddingTop: 0,
            paddingBottom: 50,
            paddingLeft: 0,
            paddingRight: 0,
            forceFit: true,
            soundEnable: true,
            webgl: false
        };

        $('#df_magazine').flipBook(images, options);
    };

    // 🔹 Decide mode
    useEffect(() => {
        if (!data || !flipbookRef.current) return;

        const $ = window.jQuery;

        const pdfUrl = data?.pdf_url;
        const images = data?.images_data?.map(x => x.images);

        const run = () => {
            if (pdfUrl) {
                initPdfFlipbook(pdfUrl);
            } else if (images && images.length > 0) {
                initImageFlipbook(images);
            } else {
                console.error('No valid data');
            }
        };

        if ($ && $.fn.flipBook) {
            run();
        } else {
            const timer = setTimeout(run, 1000);
            return () => clearTimeout(timer);
        }

        return () => destroyFlipbook();

    }, [data]);

    if (isLoading) {
        return (
            <div className='flipbook-page'>
                <div className="flipbook-loading">Loading magazine...</div>
            </div>
        );
    }

    return (
        <div className='flipbook-page'>
            <button className="back-btn" onClick={handleGoBack}>
                ← Back
            </button>

            <div
                ref={flipbookRef}
                id="df_magazine"
                className="flipbook-container"
            ></div>
        </div>
    );
}

export default Flipbook;